<ng-container *ngIf="(account$ | async) as account">

  <p-table 
    #eventTypesTable 
    [value]="account.data.eventTypes" 
    [globalFilterFields]="['name']"
    styleClass="mt-5 p-datatable-striped" 
    dataKey="_meta.id" 
    responsiveLayout="scroll"
  >

    <ng-template pTemplate="caption">
      <div class="p-d-flex">
        <span class="p-input-icon-left p-ml-auto">
          <i class="pi pi-search"></i>
          <input pInputText type="text" (input)="eventTypesTable.filterGlobal($any($event).target.value, 'contains')" placeholder="Search keyword" />
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="header">
      <tr>
        <th>Event type</th>
        <th style="width: 16rem">Purpose <i class="pi pi-info-circle text-500 text-sm" pTooltip="What an event of this type uses a venue for. Places we've used are counted per purpose, so the venue map can rank venues by it. Unset counts as other."></i></th>
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-eventType>
      <tr [pSelectableRow]="eventType">
        <td class="eventtype-text">{{ eventType.name }}<div *ngIf="usageOf(eventType) as u" class="text-500 text-xs">used {{ u.events | number }} time{{ u.events === 1 ? '' : 's' }}</div></td>
        <td class="eventtype-purpose">
          <p-dropdown [baseZIndex]="12000" [options]="purposes" optionLabel="label" optionValue="value" [ngModel]="eventType.purpose" (ngModelChange)="onPurposeChange(eventType, $event)"
                      [showClear]="true" appendTo="body" styleClass="w-full"
                      [placeholder]="usageOf(eventType)?.suggested ? 'Suggested: ' + purposeLabel(usageOf(eventType)?.suggested) : 'Purpose'"></p-dropdown>
        </td>
        <td class="eventType-actions">
          <button pButton pRipple type="button" icon="pi pi-pencil" (click)="onEditEventType($event, eventType)" class="p-button-rounded p-button-text"></button>
          <button *ngIf="!eventType.disabled" pButton pRipple type="button" icon="pi pi-trash" (click)="onDeleteEventType($event, eventType)" class="p-button-rounded p-button-danger p-button-text"></button>
          <button *ngIf="eventType.disabled" pButton pRipple type="button" icon="pi pi-refresh" (click)="onRestoreEventType($event, eventType)" class="p-button-rounded p-button-success p-button-text"></button>
        </td>
      </tr>
    </ng-template>

  </p-table>

</ng-container>